// import React, { useState } from "react";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import "../style.css"; // Custom styles
// import { useNavigate } from "react-router-dom";

// const TheCalendar = ({ value, setValue, tileContent }) => {
//   const [showDetails, setShowDetails] = useState(false);
//   const navigate = useNavigate();

//   const toggleDetails = () => setShowDetails(!showDetails);

//   const calculateNights = (dates) => {
//     if (!dates || dates.length !== 2) return 0;
//     const [start, end] = dates;
//     const timeDiff = Math.abs(end - start);
//     const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
//     return daysDiff;
//   };

//   const nights = calculateNights(value);

//   const handleBookNow = () => {
//     if (value && value.length === 2) {
//       const [start, end] = value;
//       const startDate = start.toISOString().split("T")[0];
//       const endDate = end.toISOString().split("T")[0];
//       navigate(`/checkout?start=${startDate}&end=${endDate}`);
//     }
//   };

//   return (
//     <div className="flex flex-col items-center bg-white rounded-xl p-5 shadow-xl pb-12">
//       <Calendar
//         onChange={setValue}
//         value={value}
//         minDate={new Date(2025, 3, 3)}
//         selectRange={true}
//         className="mt-6 border-none"
//         tileContent={tileContent}
//       />
//       <button
//         disabled={!value || value.length !== 2}
//         onClick={handleBookNow}
//         className="disabled:bg-gray-300 bg-black rounded-xl text-white w-full my-4 py-4 text-[18px] font-semibold"
//       >
//         Book Now
//       </button>

//       {value && value.length === 2 && (
//         <div className="w-full px-2">
//           <button
//             onClick={toggleDetails}
//             className="text-black font-medium mt-2 text-[18px] underline flex items-center text-center"
//           >
//             {showDetails ? (
//               <>
//                 Hide Price Details{" "}
//                 <svg
//                   viewBox="0 0 20 20"
//                   aria-hidden="true"
//                   focusable="false"
//                   fill="currentColor"
//                   xmlns="http://www.w3.org/2000/svg"
//                   class="h-[18px] ml-1"
//                 >
//                   <path d="M15.484 12.452c-.436.446-1.043.481-1.576 0L10 8.705l-3.908 3.747c-.533.481-1.141.446-1.574 0-.436-.445-.408-1.197 0-1.615.406-.418 4.695-4.502 4.695-4.502a1.095 1.095 0 0 1 1.576 0s4.287 4.084 4.695 4.502c.409.418.436 1.17 0 1.615z"></path>
//                 </svg>
//               </>
//             ) : (
//               <>
//                 Show Price Details{" "}
//                 <svg
//                   viewBox="0 0 20 20"
//                   aria-hidden="true"
//                   focusable="false"
//                   fill="currentColor"
//                   xmlns="http://www.w3.org/2000/svg"
//                   class="h-[18px] ml-1"
//                 >
//                   <path d="M4.516 7.548c.436-.446 1.043-.481 1.576 0L10 11.295l3.908-3.747c.533-.481 1.141-.446 1.574 0 .436.445.408 1.197 0 1.615-.406.418-4.695 4.502-4.695 4.502a1.095 1.095 0 0 1-1.576 0S4.924 9.581 4.516 9.163c-.409-.418-.436-1.17 0-1.615z"></path>
//                 </svg>
//               </>
//             )}
//           </button>
//           {showDetails && (
//             <div className="mt-2">
//               <div className="flex justify-between">
//                 <span>Room Price</span>
//                 <span>${nights * 99}</span>
//               </div>
//               {/* <div className="flex justify-between">
//                 <span>Fees</span>
//                 <span>$20</span>
//               </div>
//               <div className="flex justify-between">
//                 <span>Taxes</span>
//                 <span>$15</span>
//               </div> */}
//             </div>
//           )}
//           <hr className="my-4 bg-[#dddddd]" />
//           <div className="flex justify-between font-bold text-[18px]">
//             <span>Total Including Taxes</span>
//             {/* <span>${totalPrice}</span> */}
//             <span>${nights * 99}</span>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TheCalendar;

import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../style.css";
import { useNavigate } from "react-router-dom";

const TheCalendar = ({ value, setValue, tileContent }) => {
  const [showDetails, setShowDetails] = useState(false);
  const navigate = useNavigate();

  const toggleDetails = () => setShowDetails(!showDetails);

  // Special holiday date ranges (months are 0-indexed)
  const holidayRanges = [
    [new Date(2025, 5, 20), new Date(2025, 5, 22)], // Juneteenth weekend: June 20–22
    [new Date(2025, 6, 4), new Date(2025, 6, 6)],   // Independence Day weekend: July 4–6
    [new Date(2025, 7, 30), new Date(2025, 8, 1)],  // Labor Day weekend: Aug 30 - Sep 1
    [new Date(2025, 9, 11), new Date(2025, 9, 13)], // Columbus Day weekend: Oct 11–13
    [new Date(2025, 10, 7), new Date(2025, 10, 11)],// Veterans Day: Nov 7–11
    [new Date(2025, 10, 26), new Date(2025, 10, 30)],// Thanksgiving: Nov 26–30
    [new Date(2025, 11, 19), new Date(2025, 11, 28)],// Christmas/Hanukkah: Dec 19–28
    [new Date(2025, 11, 31), new Date(2026, 0, 2)],  // New Year's Eve/Day: Dec 31 – Jan 2, 2026
  ];

  // Helper to check if a date is within a range inclusive
  const isInRange = (date, start, end) => {
    return date >= start && date <= end;
  };

  // Tax rates
  const TAX_WEEKDAY = 0.085;
  const TAX_WEEKEND = 0.085;
  const TAX_HOLIDAY = 0;

  // Prices per night
  const PRICE_WEEKDAY = 149;
  const PRICE_WEEKEND = 195;
  const PRICE_HOLIDAY = 226;

  // Calculate counts of nights per category
  const calculatePriceDetails = (dates) => {
    if (!dates || dates.length !== 2) return { weekdayNights: 0, weekendNights: 0, holidayNights: 0 };

    const [start, end] = dates;
    let weekdayNights = 0,
      weekendNights = 0,
      holidayNights = 0;

    let currentDate = new Date(start);

    // Loop from start date to day before end date
    while (currentDate < end) {
      const isHoliday = holidayRanges.some(([holidayStart, holidayEnd]) =>
        isInRange(currentDate, holidayStart, holidayEnd)
      );
      const day = currentDate.getDay();

      if (isHoliday) {
        holidayNights++;
      } else if (day === 0 || day === 6) {
        weekendNights++;
      } else {
        weekdayNights++;
      }

      currentDate.setDate(currentDate.getDate() + 1);
    }

    return { weekdayNights, weekendNights, holidayNights };
  };

  const { weekdayNights, weekendNights, holidayNights } = calculatePriceDetails(value);

  // Calculate subtotals
  const subtotalWeekday = weekdayNights * PRICE_WEEKDAY;
  const subtotalWeekend = weekendNights * PRICE_WEEKEND;
  const subtotalHoliday = holidayNights * PRICE_HOLIDAY;

  // Calculate taxes
  const taxWeekday = subtotalWeekday * TAX_WEEKDAY;
  const taxWeekend = subtotalWeekend * TAX_WEEKEND;
  const taxHoliday = subtotalHoliday * TAX_HOLIDAY;

  // Total including taxes
  const totalPriceIncludingTaxes =
    subtotalWeekday +
    subtotalWeekend +
    subtotalHoliday +
    taxWeekday +
    taxWeekend +
    taxHoliday;

  // Calculate total nights for display (sum all nights)
  const totalNights = weekdayNights + weekendNights + holidayNights;

  const handleBookNow = () => {
    if (value && value.length === 2) {
      const [start, end] = value;
      const startDate = start.toISOString().split("T")[0];
      const endDate = end.toISOString().split("T")[0];
      navigate(`/checkout?start=${startDate}&end=${endDate}`);
    }
  };

  return (
    <div className="flex flex-col items-center bg-white rounded-xl p-5 shadow-xl pb-12">
      <Calendar
        onChange={setValue}
        value={value}
        minDate={new Date(2025, 5, 1)}
        selectRange={true}
        className="mt-6 border-none"
        // tileContent={tileContent}
      />
      <button
        disabled={!value || value.length !== 2}
        onClick={handleBookNow}
        className="disabled:bg-gray-300 bg-black rounded-xl text-white w-full my-4 py-4 text-[18px] font-semibold"
      >
        Book Now
      </button>

      {value && value.length === 2 && (
        <div className="w-full px-2">
          <button
            onClick={toggleDetails}
            className="text-black font-medium mt-2 text-[18px] underline flex items-center text-center"
          >
            {showDetails ? (
              <>
                Hide Price Details{" "}
                <svg
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                  focusable="false"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-[18px] ml-1"
                >
                  <path d="M15.484 12.452c-.436.446-1.043.481-1.576 0L10 8.705l-3.908 3.747c-.533.481-1.141.446-1.574 0-.436-.445-.408-1.197 0-1.615.406-.418 4.695-4.502 4.695-4.502a1.095 1.095 0 0 1 1.576 0s4.287 4.084 4.695 4.502c.409.418.436 1.17 0 1.615z"></path>
                </svg>
              </>
            ) : (
              <>
                Show Price Details{" "}
                <svg
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                  focusable="false"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-[18px] ml-1"
                >
                  <path d="M4.516 7.548c.436-.446 1.043-.481 1.576 0L10 11.295l3.908-3.747c.533-.481 1.141-.446 1.574 0 .436.445.408 1.197 0 1.615-.406.418-4.695 4.502-4.695 4.502a1.095 1.095 0 0 1-1.576 0S4.924 9.581 4.516 9.163c-.409-.418-.436-1.17 0-1.615z"></path>
                </svg>
              </>
            )}
          </button>
          {showDetails && (
            <div className="mt-2 space-y-1">
              <div className="flex justify-between">
                <span>Weekday Nights ({PRICE_WEEKDAY}$)</span>
                <span>{weekdayNights} nights | Subtotal: ${subtotalWeekday.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span>Tax (8.5%)</span>
                <span>${taxWeekday.toFixed(2)}</span>
              </div>

              <div className="flex justify-between">
                <span>Weekend Nights ({PRICE_WEEKEND}$)</span>
                <span>{weekendNights} nights | Subtotal: ${subtotalWeekend.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span>Tax (8.5%)</span>
                <span>${taxWeekend.toFixed(2)}</span>
              </div>

              <div className="flex justify-between">
                <span>Holiday Nights ({PRICE_HOLIDAY}$)</span>
                <span>{holidayNights} nights | Subtotal: ${subtotalHoliday.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                {/* <span>Tax (10%)</span> */}
                {/* <span>${taxHoliday.toFixed(2)}</span> */}
              </div>
            </div>
          )}
          <hr className="my-4 bg-[#dddddd]" />
          <div className="flex justify-between font-bold text-[18px]">
            <span>Total Including Taxes</span>
            <span>${totalPriceIncludingTaxes.toFixed(2)}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TheCalendar;
